const getters = {
  // login、signup
  userTemp: state => state.user.temp,
  token: state => state.user.token,
  name: state => state.user.name,
  userow: state => state.user.row,
  type: state => state.user.type,
  isExpire: state => state.user.isExpire,
  isEnExpire: state => state.user.isEnExpire,
  isClear: state => state.user.isClear,
  isClose: state => state.user.isClose,
  userRow: state => state.user.userRow,
  userInfo: state => state.user.userInfo,
  // news
  newsTotal: state => state.news.total,
  newsRows: state => state.news.rows,
  newsRow: state => state.news.row,
  newsYears: state => state.news.years,
  newsPermission: state => state.news.permission,
  newsErrCode: state => state.news.errcode,
  viewMode: state => state.news.viewMode,
  isLoading: state => state.news.isLoading,
  newsItems: state => state.news.items,
  // trade
  tradeTotal: state => state.trade.total,
  tradeRows: state => state.trade.rows,
  tradeRow: state => state.trade.row,
  tradeTemp: state => state.trade.temp,
  tradeSpot: state => state.trade.spot,
  tradeFutures: state => state.trade.futures,
  tradeCounter: state => state.trade.counter,
  tradeDict: state => state.trade.dict,
  tradeNav: state => state.trade.nav,
  tradeIsRefresh: state => state.trade.isRefresh,
  // data
  beefDataTotal: state => state.data.total,
  exportToChinas: state => state.data.exportToChina,
  exportToChinasTable: state => state.data.exportToChinaTable,
  exportToChinaOrigins: state => state.data.exportToChinaOrigin,
  countrySlaughters: state => state.data.countrySlaughter,
  countrySlaughterOrigins: state => state.data.countrySlaughterOrigin,
  plantSlaughters: state => state.data.plantSlaughter,
  plantSlaughterOrigins: state => state.data.plantSlaughterOrigin,
  plantSlaughterPlantNos: state => state.data.plantSlaughterPlantNo,
  greyChannels: state => state.data.greyChannel,
  greyChannelOrigins: state => state.data.greyChannelOrigin,
  customDatas: state => state.data.customData,
  customItems: state => state.data.customItem,
  customOrigins: state => state.data.customOrigin,
  customReports: state => state.data.customReport,
  approvePlantOrigins: state => state.data.approvePlantOrigin,
  approvePlantPlantNos: state => state.data.approvePlantPlantNo,
  approvePlantProvinces: state => state.data.approvePlantProvince,
  approvePlantDatas: state => state.data.approvePlantData,
  approvePlantPatterns: state => state.data.approvePlantPattern,
  porkToChinas: state => state.data.porkToChina,
  porkToChinaOrigins: state => state.data.porkToChinaOrigin,
  marketIndexTab: state => state.data.marketIndexTab,
  plantPermission: state => state.data.plantPermission
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js